import axiosInstance from '../axios/axiosInstance';
import { BookAppendixRequest } from '../model/request';
import { BookAppendix } from '../model/response';

export const findAllBookAppendixByBookId = async (bookId: string) => {
  const { data } = await axiosInstance.get<BookAppendix[]>('book-appendices/find-all-by-book', {
    params: {
      bookId,
      fromCMS: true,
    },
  });
  return data;
};

export const addBookAppendix = async (request: BookAppendixRequest) => {
  const { data } = await axiosInstance.post<String>('/book-appendices', request);
  return data;
};

export const updateBookAppendix = async (id: string, request: BookAppendixRequest) => {
  await axiosInstance.put<String>(`/book-appendices/${id}`, request);
};

export const deleteBookAppendix = async (id: string) => {
  await axiosInstance.delete(`/book-appendices/${id}`);
};

export const pushBookAppendixUp = async (id: string) => {
  return await axiosInstance.put(`/book-appendices/push-up/${id}`);
};

export const pushBookAppendixDown = async (id: string) => {
  return await axiosInstance.put(`/book-appendices/push-down/${id}`);
};
